import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Params, Router, NavigationExtras} from "@angular/router";
import { ClipboardService } from 'ngx-clipboard';
import { EventService } from "../../core/services/event.service";
import { HybridToolsService } from '../../core/services/hybrid-tools.service';


@Component({
    selector: 'facebook-fundraiser-page',
    templateUrl: './facebook-fundraiser-page.component.html'
})
export class FacebookFundraiserPageComponent implements OnInit {


    public facebookFundraiserUrl: string;
    public fundraiserDisplayName: string;
    private facebookFundraiserUrlCopied: boolean;

    constructor(private activatedRoute: ActivatedRoute,
        public eventService: EventService,
        private clipboard: ClipboardService,
        private router: Router,
        private renderer: Renderer2,
        public hybridToolsService: HybridToolsService) {
        this.eventService.onEventChange.subscribe(event => {
            if (this.router.url.includes('/facebook/fundraiser')) {
                var fundraiser = this.eventService.selectedEvent.gql.Participant[0].fundraiser;
                if (fundraiser.activeFacebookFundraiserProfiles.length > 0) {
                    this.router.navigate(['/facebook/fundraiser', fundraiser.activeFacebookFundraiserProfiles[0].facebookFundraiserId]);
                } else if (this.canDisplayFacebookFundraiserPage()){
                    this.router.navigate(['/facebook/fundraiser']);
                } else {
                    this.router.navigate(['/home']);
                }
            }
        });
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.facebookFundraiserUrl =  'https://www.facebook.com/donate/' + params['facebookFundraiserID'] + '/';
        });
        this.facebookFundraiserUrlCopied = false;
        var constituent = this.eventService.selectedEvent.gql.Participant[0].individualConstituent;
        this.fundraiserDisplayName = constituent.firstName + ' ' + constituent.lastName;
    }

    canDisplayFacebookFundraiserPage() {
        return this.eventService.isFacebookLinkingSupportedForSelectedEvent();
    }

    copyFacebookFundraiserUrlToClipboard = () => {
        this.clipboard.copyFromContent(this.facebookFundraiserUrl); //FIXME: migration, this.renderer);
        this.facebookFundraiserUrlCopied = true;
    }

}
